import { SortOptions } from '@awaze/mfe-common.configs.brand/dist/brand.types'
import { SORT_OPTIONS_ENUM } from 'src/constants'

interface HandleInitialSortOptionsConfigProps {
  isInNovasolPIMExperiment: boolean
  isDatedSearch: string | undefined
  sortConfig: {
    dated: SortOptions
    undated: SortOptions
  }
}

export const handleInitialSortOptionsConfig = ({
  isInNovasolPIMExperiment,
  isDatedSearch,
  sortConfig,
}: HandleInitialSortOptionsConfigProps): SortOptions => {
  const novasolV2Config = {
    dated: {
      default: SORT_OPTIONS_ENUM.RECOMMENDED,
      options: [
        SORT_OPTIONS_ENUM.RECOMMENDED,
        SORT_OPTIONS_ENUM.PRICE_ASCENDING,
        SORT_OPTIONS_ENUM.PRICE_DESCENDING,
        SORT_OPTIONS_ENUM.SLEEPS_ASCENDING,
        SORT_OPTIONS_ENUM.SLEEPS_DESCENDING,
        SORT_OPTIONS_ENUM.REVIEWS_DESCENDING,
        SORT_OPTIONS_ENUM.NO_SORT,
      ],
    },
    undated: {
      default: SORT_OPTIONS_ENUM.RECOMMENDED,
      options: [
        SORT_OPTIONS_ENUM.RECOMMENDED,
        SORT_OPTIONS_ENUM.NO_SORT,
        SORT_OPTIONS_ENUM.SLEEPS_ASCENDING,
        SORT_OPTIONS_ENUM.SLEEPS_DESCENDING,
        SORT_OPTIONS_ENUM.REVIEWS_DESCENDING,
      ],
    },
  }

  if (isInNovasolPIMExperiment) {
    if (isDatedSearch) {
      return novasolV2Config.dated
    }
    return novasolV2Config.undated
  } else {
    if (isDatedSearch) {
      return sortConfig.dated
    }
    return sortConfig.undated
  }
}
